app.directive('treeView', ['$compile', '$state', 'RecursionHelper', '$rootScope', '$window',
function ($compile, $state, RecursionHelper, $rootScope, $window) {
    /**
     * @param {Object} node
     */
    var nodeUtil = function (node) {
        return {
            /**
             * Détermine si "node" est un regroup
             * @returns {boolean}
             */
            isRegroup: function () {
                return node.type_noeud == '0';
            },
            /**
             * Détermine si "node" est un site
             * @returns {boolean}
             */
            isSite: function () {
                return node.type_noeud == '1';
            },

            /**
             * Détermine si "node" est root ou pas
             * @returns {boolean}
             */
            isRoot: function () {
                return node.parent == 0 || node.parent == '0';
            },

            // resetHide: function() {
            //  node.hide = false;
            //  angular.forEach(node.childs, function(value) {
            //      nodeUtil(value).resetHide();
            //  });
            // },
            //

            /**
             *
             * @returns {boolean}
             */
            isShow: function () {
                return angular.isUndefined(node.hide) || node.hide === false;
            },

            /**
             * (De)plis tous les noeuds de l'arbo : modificaiton de la propriete 'extend' du noeud à 'true' ou false
             * @param  {Boolean} show
             */
            showAll: function (show) {
                this.setExpand(show);
                // si root
                if (this.isRoot()) {
                    this.setExpand(true);
                }

                // pour chaque enfants
                angular.forEach(node.childs, function (value) {
                    nodeUtil(value).showAll(show);
                });
            },

            setExpand: function (value) {
                node.expand = value;
            }
        }
    };


    return {
        restrict: "E",
        templateUrl: "/templates/partials/directives/tree-view.html",
        scope: {
            tree: '=',
            nodes: '=',
            treeSettings: '=',
            search: '=',
            nodeSearched: '=',
            expandAll: '=',
            account: '=',
            showNodesHasProp: '='
        },
        compile: function (element) {
            return RecursionHelper.compile(element, function (scope) {

                /* ------------ Services ------------ */
                var descendantService = function (node) {
                    this.node = node;
                };

                descendantService.prototype = {
                    /**
                     * Compte le nombre de descendants (de)selection et total à partir d'un noeud
                     * @return {Array}
                     */
                    count: function () {
                        var count = {
                            total: 0,
                            checked: 0,
                            unchecked: 0
                        }, result;


                        if (!scope.treeSettings.isFilterArbo) {
                            angular.forEach(this.node.childs, function (value) {
                                // si checke
                                if (nodeIsChecked(value)) {
                                    count.checked++;
                                } else {
                                    count.unchecked++;
                                }

                                // Vérification des descendants de ce descendant
                                result = (new descendantService(value)).count();
                                count.checked += result.checked;
                                count.unchecked += result.unchecked;
                            });
                        } else {
                            angular.forEach(this.node.childs, function (value) {
                                // si restreint au noeud de type enfant
                                if (nodeUtil(value).isRegroup()) {
                                    result = (new descendantService(value)).count();
                                    count.checked += result.checked;
                                    count.unchecked += result.unchecked;
                                } else {
                                    // si checke
                                    if (nodeIsChecked(value)) {
                                        count.checked++;
                                    } else {
                                        count.unchecked++;
                                    }
                                }
                            });
                        }
                        count.total = count.checked + count.unchecked;

                        return count;
                    },


                    /**
                     * Coche les descendants d'un noeud
                     */
                    check: function () {
                        // Pour les enfants du noeud
                        angular.forEach(this.node.childs, function (value, key) {

                            if (scope.nodeIsNotGroupWithoutChild(value)) {
                                if (nodeUtil(value).isRegroup()) {
                                    (new descendantService(value)).check(); // check les descendants de l'enfant
                                    // check du parent si isFilterArbo sinon, uncheck
                                    checkNode(value, scope.treeSettings.isFilterArbo);
                                } else {
                                    // Si aucune recherche actuelle tout les noeuds sont 'recherché' = affichés
                                    if (scope.isNoSearch()) {
                                        if (nodeUtil(value).isShow()) {
                                            checkNode(value, true); // check le noeud
                                        }
                                    } else {
                                        // Verifie que les noeud checké sont recherché pour ne pas checker les noeud non visible (non recherché)
                                        if (scope.nodeSearched != [] && scope.nodeSearched[key]) {
                                            checkNode(value, true); // check le noeud
                                        }
                                    }
                                }
                            } else {
                                checkNode(value, false); // pour être sur que les groupes sans enfants ne soient pas check
                            }
                        });
                    },

                    /**
                     * Decoche les descendants d'un noeud
                     */
                    uncheck: function () {
                        // Pour les enfants du noeud
                        angular.forEach(this.node.childs, function (value, key) {

                            // si type parent :
                            if (nodeUtil(value).isRegroup()) {
                                (new descendantService(value)).uncheck(); // uncheck les descendants de l'enfant
                                checkNode(value, false);
                            } else {
                                // Si aucune recherche actuelle tout les noeuds sont 'recherché' = affichés
                                if (scope.isNoSearch()) {
                                    if (nodeUtil(value).isShow()) {
                                        checkNode(value, false); // UnCheck le noeud
                                    }
                                } else {
                                    if (scope.nodeSearched != [] && scope.nodeSearched[key]) {
                                        checkNode(value, false); // UnCheck le noeud
                                    }
                                }
                            }
                        });
                    },

                    /**
                     * Replie les descendants d'un noeud
                     */
                    close: function () {
                        nodeUtil(this.node).setExpand(false);
                        angular.forEach(this.node.childs, function (value) {
                            (new descendantService(value)).close();
                        });
                    },

                    /**
                     * Verifie si au moins un descendant d'un noeud est trouvé (filtre de recherche)
                     * @return {Boolean}
                     */
                    areSearched: function () {
                        var isSearch = false;
                        angular.forEach(this.node.childs, function (value, key) {
                            if (!isSearch) {
                                // si il est dans le nodeSearched
                                if (scope.nodeSearched[key]) {
                                    isSearch = true;
                                } else {
                                    isSearch = (new descendantService(value)).areSearched(); // sinon on verifie pour son enfant
                                }
                            }
                        });

                        return isSearch;
                    },

                    /**
                     * Verifie si au moins un descendant d'un noeud est coché
                     * @return {Boolean}
                     */
                    areChecked: function () {
                        var isChecked = false;
                        angular.forEach(this.node.childs, function (value) {
                            if (!isChecked) {
                                if (nodeIsChecked(value)) {
                                    isChecked = true;
                                } else {
                                    isChecked = (new descendantService(value)).areChecked(); // sinon on verifie pour son enfant
                                }
                            }
                        });

                        return isChecked;
                    },

                    /**
                     * Vérifie que le noeud à une propriété égale au filtre
                     * @param  Object property Propriété du noeud à verifier
                     * @param  Object filter   Filtre
                     * @return Boolean          true si la propriete est egale au filtre
                     */
                    arePropFilter: function (property, filter) {
                        var value = false;
                        angular.forEach(this.node.childs, function (child) {
                            if (!value) {
                                if (angular.isDefined(child[property]) && child[property] == filter.value) {
                                    value = true;
                                } else {
                                    value = (new descendantService(child)).arePropFilter(property, filter); // sinon on verifie pour son enfant
                                }
                            }
                        });

                        return value;
                    }

                };

                var searchService = function (searchTerm, node) {
                    if (angular.isUndefined(searchTerm)) {
                        searchTerm = '';
                    }
                    this.search = searchTerm.toLowerCase();
                    this.node = node;

                    var that = this;

                    /**
                     * Recherche dans les descendants si le label correspond au filtre de recherche
                     * @return {Boolean}
                     */
                    this.searchOnDescendants = function () {
                        if (angular.isUndefined(scope.search)) {
                            return false;
                        }
                        var label = node[scope.treeSettings.libelle].toLowerCase();
                        var nu = nodeUtil(this.node);

                        // Si label correspond à la recherche
                        if (label.indexOf(this.search) > -1) {
                            if (nu.isShow()) {
                                scope.nodeSearched[parseInt(node.noeud)] = true;
                                if (angular.isDefined(scope.search)) {
                                    nu.setExpand(true);
                                }
                                this.markDescendantsFound();
                                return true;
                            } else {
                                return false;
                            }
                        }


                        // Pour chaque enfants du noeud
                        angular.forEach(this.node.childs, function (value) {
                            if (nodeUtil(value).isShow() && (new searchService(that.search, value)).searchOnDescendants()) {
                                nu.setExpand(true);
                            }
                        });
                        return false;
                    };

                    /**
                     * Marque les descendants d'un noeud en trouvé (filtre de recherche)
                     */
                    this.markDescendantsFound = function () {
                        angular.forEach(this.node.childs, function (value, key) {
                            scope.nodeSearched[key] = true;
                            (new searchService(that.search, value)).markDescendantsFound();
                        });
                    };
                };
                /* ---------- !Service! ---------- */


                /* ------------ Global Functions ------------ */
                var nodeIsChecked = function (node) {
                    return (angular.isDefined(scope.nodes[parseInt(node.noeud)]) && scope.nodes[parseInt(node.noeud)].is_checked);
                };

                var checkNode = function (node, value) {
                    scope.nodes[parseInt(node.noeud)] = {
                        type_noeud: node.type_noeud,
                        is_checked: value,
                        parent: node.parent,
                        nom: node.site,
                        id: node.noeud
                    };
                };


                var filterSelectedNodes = function (node) {

                    if (angular.isUndefined(node.hide) || !node.hide) {
                        // si coche
                        if (nodeIsChecked(node)) {
                            node.hide = false;
                        } else {
                            node.hide = !(new descendantService(node)).areChecked();
                        }
                        // pour chaque enfants
                        angular.forEach(node.childs, function (value) {
                            filterSelectedNodes(value);
                        });
                    }
                }


                var resetFilterSelected = function (node) {
                    var filters = angular.extend({}, scope.showNodesHasProp);
                    delete filters.is_checked;

                    if (nodeIsFiltering(node, filters) == false) {
                        node.hide = false;
                    }

                    angular.forEach(node.childs, function (child) {
                        resetFilterSelected(child);
                    });
                }


                var resetFilterByProperty = function (node, property) {

                    var filters = angular.extend({}, scope.showNodesHasProp);
                    delete filters[property];
                    delete filters.is_checked;

                    // Si filtre sur une propriete du noeud
                    if (nodeIsFiltering(node, filters) == false) {
                        node.hide = false;
                    }

                    if (scope.showNodesHasProp.is_checked.active) {
                        // Si filtre sur selection du noeud  dans l'arbo activé
                        if (nodeIsChecked(node) == false || (nodeUtil(node).isRegroup() && ((new descendantService(node)).areChecked() == false))) {
                            node.hide = true; // cache les sites non selectionné ou les groupement qui n'ont pas de sites selectionné
                        }
                    }

                    angular.forEach(node.childs, function (child) {
                        resetFilterByProperty(child, property);
                    });
                }


                var nodeIsFiltering = function (node, filters) {
                    var isFilter = false;

                    angular.forEach(filters, function (filter, propFilter) {
                        if (!isFilter) {
                            if (filter.active) {
                                if (!filter.check_child && nodeUtil(node).isRegroup()) {
                                    if ((new descendantService(node)).arePropFilter(propFilter, filter) == false) {
                                        isFilter = true;
                                        return true;
                                    }
                                } else if (angular.isUndefined(node[propFilter]) || node[propFilter] != filter.value) {
                                    isFilter = true;
                                    return true;
                                }
                            }
                        }
                    });
                    return isFilter;
                }


                var filterNodeByProp = function (node, prop, filter) {
                    if (angular.isUndefined(node.hide) || !node.hide) {
                        if (!filter.check_child && nodeUtil(node).isRegroup()) {
                            node.hide = !(new descendantService(node)).arePropFilter(prop, filter);
                        } else {
                            if (node[prop] == filter.value) {
                                node.hide = false;
                            } else {
                                node.hide = !(new descendantService(node)).arePropFilter(prop, filter);
                            }
                        }
                    }

                    // pour chaque enfants
                    angular.forEach(node.childs, function (child) {
                        filterNodeByProp(child, prop, filter);
                    });
                }



                scope.isNoSearch = function () {
                    return scope.search === '' || angular.isUndefined(scope.search);
                };
                /* ---------- !Global Functions! ---------- */




                /* ------------ Watchers ------------ */
                /**
                 * Ecouteur sur le filtre de recherche
                 */
                if (angular.isUndefined(scope.$parent.node)) {
                    //Recherche dans l'arbo les noeuds ayant pour label la valeur en parametre
                    scope.$watch("search", function (searchTerm) {
                        if (searchTerm !== false) {
                            scope.nodeSearched = [];

                            // Pour chaque Noeud (ROOT)
                            angular.forEach(scope.tree, function (node) {
                                (new searchService(searchTerm, node)).searchOnDescendants();
                            });
                        }
                    });


                    scope.$watch("showNodesHasProp.is_checked.active", function (value) {
                        if (value) {
                            angular.forEach(scope.tree, function (node) {
                                filterSelectedNodes(node);
                            });
                        } else {
                            angular.forEach(scope.tree, function (node) {
                                resetFilterSelected(node);
                            });
                        }
                    });


                    scope.$watch("showNodesHasProp.amiante_status.value", function (value) {
                        if (angular.isDefined(scope.showNodesHasProp)) {
                            if (scope.showNodesHasProp.amiante_status.active) {
                                angular.forEach(scope.tree, function (node) {
                                    resetFilterByProperty(node, 'amiante_status');
                                    filterNodeByProp(node, 'amiante_status', scope.showNodesHasProp.amiante_status);
                                });
                            } else {
                                angular.forEach(scope.tree, function (node) {
                                    resetFilterByProperty(node, 'amiante_status');
                                });
                            }
                        }
                    });

                    scope.$watch("expandAll", function (newValue) {
                        angular.forEach(scope.tree, function (node) {
                            nodeUtil(node).showAll(newValue);
                        });
                    });
                }
                /* ---------- !Watchers! ---------- */




                /* ------------ Scope Functions ------------ */

                scope.getChilds = function (node) {
                    if (!angular.isObject(node)) {
                        var ret = {};
                        ret[scope.tree[0].noeud] = scope.tree[0];

                        return ret;
                    } else {
                        if (angular.isUndefined(node.childs)) {
                            node.childs = {};
                            angular.forEach(scope.tree, function (value) {
                                if (value.parent == node.noeud) {
                                    node.childs[value.noeud] = value;
                                }
                            });
                        }

                        return node.childs;
                    }
                };

                scope.nodeIsNotGroupWithoutChild = function (node) {
                    var result = false;

                    if (nodeUtil(node).isRegroup()) {
                        if (node.childs.length != 0) {
                            angular.forEach(node.childs, function (value) {
                                if (nodeUtil(value).isRegroup()) {
                                    if (!result) {
                                        result = scope.nodeIsNotGroupWithoutChild(value);
                                    }
                                } else {
                                    result = true;
                                }
                            });
                        } else {
                            result = false;
                        }
                    } else {
                        result = true;
                    }

                    return result;
                };


                /**
                 * Vérifie si le noeud doit etre visible ou non dans l'arbo
                 * @param  {object} node
                 * @return {Boolean}
                 */
                scope.nodeIsShow = function (node) {
                    var nodeId = parseInt(node.noeud);
                    var nu = nodeUtil(node);

                    if (scope.isNoSearch()) {
                        return nu.isShow();
                    }

                    if (nu.isRoot() || scope.nodeSearched[nodeId]) {
                        return true;
                    }

                    // si c'est un noeud de type enfant :
                    if (nu.isSite()) {
                        return false;
                    }

                    // sinon, regarde si des desc sont recherchés
                    return (new descendantService(node)).areSearched();
                };

                /**
                 * Au moment où le noeud est (de)coche : (de)coche les descendants si c'est un noeud de type parent
                 * @param  {object} node
                 */
                scope.nodeCheckboxChange = function (node) {

                    var nodeDescendants = new descendantService(node);

                    // SI on ne veux checker que les type enfants
                    if (scope.treeSettings.isFilterArbo) {
                        if (nodeUtil(node).isRegroup()) {
                            // si des enfants sont checked
                            if (nodeDescendants.count().checked) {
                                // si on check le groupement
                                if (nodeIsChecked(node)) {
                                    nodeDescendants.check();
                                } else {
                                    nodeDescendants.uncheck();
                                    let parentNode = scope.nodes[parseInt(node.parent)];
                                    while (angular.isDefined(parentNode) && parentNode.is_checked) {
                                        parentNode.is_checked = false;
                                        parentNode = scope.nodes[parseInt(parentNode.parent)];
                                    }
                                }
                            } else {
                                nodeDescendants.check();
                            }
                        } else {
                            let parentNode = scope.nodes[parseInt(node.parent)];
                            while (angular.isDefined(parentNode) && parentNode.is_checked) {
                                parentNode.is_checked = false;
                                parentNode = scope.nodes[parseInt(parentNode.parent)];
                            }
                        }
                    } else {
                        // SI on veux checker les type parent et enfant
                        if (nodeUtil(node).isRegroup()) {
                            nodeDescendants.uncheck(); // uncheck des desc si on check ou uncheck le parent
                        }
                        if (nodeIsChecked(node)) {
                            scope.nodes[parseInt(node.parent)].is_checked = false; // uncheck Asc
                        }
                    }
                };

                /**
                 * Au clique sur le label : Etend ou Replis des noeuds de type parent
                 * @param  node {object}
                 */
                scope.selectNode = function (node) {
                    var nu = nodeUtil(node);
                    scope.expandAll = false; // reset le expand all a la fermeture d'un groupe de noeud

                    // si c'est un noeud de type enfant :
                    if (nu.isSite()) {
                        checkNode(node, !scope.nodes[node.noeud]);
                    }
                    nu.setExpand(!node.expand);

                    // Si fermeture
                    if (!node.expand) {
                        (new descendantService(node)).close(); // Fermer aussi de tout les descendants
                    }
                };

                /**
                 * Alias pour HTML
                 * @param node
                 * @returns {boolean}
                 */
                scope.nodeIsRegroup = function (node) {
                    return nodeUtil(node).isRegroup();
                };
                scope.nodeIsSite = function (node) {
                    return nodeUtil(node).isSite();
                };

                /**
                 * Verifie si le noeud est deplie ou non
                 * @param  {object} node
                 * @return {Boolean}
                 */
                scope.nodeIsOpen = function (node) {
                    var isOpen = false;
                    var nu = nodeUtil(node);

                    //if(angular.isDefined(node.open)) return node.open;

                    if (nu.isSite()) {
                        return false;
                    }

                    // si c'est le noeud racine et qu'il n'y à pas de recherche on etend le ROOT (Tout le patrimoine) au chargement
                    if (nu.isRoot() && scope.isNoSearch() && angular.isUndefined(node.expand)) {
                        nu.setExpand(true);
                    }

                    // Si etendu
                    if (node.expand) {
                        return true;
                    }


                    // Regarde dans les descendants si un etendu
                    angular.forEach(node.childs, function (value) {
                        if (!isOpen && scope.nodeIsOpen(value)) {
                            isOpen = true;
                        }
                    });

                    return isOpen;
                };

                /**
                 * Verifie si le noeud à des enfants cochés ou non
                 * @param  {object} node
                 * @return {Boolean}
                 */
                scope.nodeHasChildsChecked = function (node) {
                    //if(angular.isDefined(node.hasAllChildsChecked)) return node.hasAllChildsChecked;
                    //if(angular.isDefined(node.hasChildsChecked)) return node.hasChildsChecked;

                    if (nodeUtil(node).isRegroup() && (new descendantService(node)).count().checked) {
                        if (!scope.treeSettings.isFilterArbo) {
                            checkNode(node, false);// si non restreint au noeud de type enfant -> uncheck du noeud si des enfants sont checké
                        }

                        return true;
                    }

                    return false;
                };

                /**
                 * Verifie pour un noeud parent, si tous ses descendants sont coches
                 * @param  {object} node
                 * @return {Boolean}
                 */
                scope.nodeHasAllChildsChecked = function (node) {
                    //if(angular.isDefined(node.hasAllChildsChecked)) return node.hasAllChildsChecked;

                    if (scope.treeSettings.isFilterArbo) {
                        // si de type parent :
                        if (nodeUtil(node).isRegroup() && scope.nodeIsNotGroupWithoutChild(node)) {
                            var countDesc = (new descendantService(node)).count();
                            // Si nombre de desc check = au nb total de desc
                            if (countDesc.checked == countDesc.total) {
                                checkNode(node, true);
                                return true;
                            } else {
                                return false;
                            }
                        }
                    }
                    return false;
                };

                scope.goToSitePage = function (node) {
                    if (nodeUtil(node).isSite()) {
                        $rootScope.onCloseBottomFilterRoot = true;
                        $window.open($state.href('app.site.infos', { site: node.noeud }), '_blank');
                    }
                };

                scope.goToAmiantePage = function (nodeId) {
                    if (angular.isDefined(scope.account)) {
                        if (angular.isDefined(scope.account.model_contrat_has_access.amiante)) {
                            $rootScope.onCloseBottomFilterRoot = true;
                            $state.go('app.contrat.amiante.synthese_amiante', {
                                contrat_id:scope.account.model_contrat_has_access.amiante,
                                noeud: nodeId
                            });
                        }
                    }
                };


                scope.accountHasModelContrat = function (model_slug) {
                    if (angular.isDefined(scope.account) && angular.isDefined(scope.account.model_contrat_has_access[model_slug])) {
                        return true;
                    }
                    return false;
                }
                /* ---------- !Scope Function! ---------- */

            });
        }
    };
}]);
